export default "__VITE_ASSET__DtE6ZMdu__"